import React from 'react';

/**
 * Draws the search-box border on a wrapper so Fluent internals
 * (clear-button margin/shadow, focus ::after) cannot cover the corners.
 */
export function SearchBoxChrome({ children }: { children: React.ReactNode }) {
  return <div className='idigest-searchbox-chrome'>{children}</div>;
}
